import React from 'react';
import { Bonuses } from './components/Bonuses';
import { Coaches } from './components/Coaches';
import { Faq } from './components/Faq';
import { LookInside } from './components/LookInside';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { MetaPixel, PIXEL_ID } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { Pain } from './components/Pain';
import { PurchasePopup } from './components/PurchasePopup';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { TopBar } from './components/TopBar';
import { Volumes } from './components/Volumes';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ivory text-charcoal selection:bg-gold selection:text-charcoal" data-id="element-0" data-mp="28te0v7ntuzkg">
      <MetaPixel data-id="element-1" data-mp="23ut97wmn5o7m" />
      <TopBar data-id="element-2" data-mp="23t8ea5wf0398" />
      <main data-id="element-3" data-mp="3ijxo6nd1puib">
        <Hero data-id="element-4" data-mp="3ikh8gaq64uzi" />
        <Stats data-id="element-5" data-mp="3ikqytzf4l45q" />
        <Pain data-id="element-6" data-mp="3ij668fcdfvai" />
        <HowItWorks data-id="element-7" data-mp="3ijpcgysnsv8p" />
        <Coaches data-id="element-8" data-mp="3ii4r9zs8ioni" />
        <Volumes data-id="element-9" data-mp="3mlayb9n68jv1" />
        <LookInside data-id="element-10" data-mp="3mkrc3gqhn9b7" />
        <Bonuses data-id="element-11" data-mp="3mk83iqmq9x9u" />
        <Pricing data-id="element-12" data-mp="3mjpyb4i388ps" />
        <Guarantee data-id="element-13" data-mp="3mj6lg27aoaim" />
        <Testimonials data-id="element-14" data-mp="3rbr9en3irte8" />
        <Faq data-id="element-15" data-mp="3rdaselgk8ijp" />
      </main>
      <Footer data-id="element-16" data-mp="3rd1a7k1rbfok" />
      <PurchasePopup data-id="element-17" data-mp="3reltuemj9e7n" />
      <noscript data-id="element-18" data-mp="5or2zhbcs60">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-19" data-mp="67yvnd9206b" />
      </noscript>
    </div>;
}